import {useEffect, useState} from "react";

export const LoadingOverlay: React.FC<any> = () => {
  const [isAlmostDone, setIsAlmostDone] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsAlmostDone(true);
    }, 2000); // switch after 2 seconds
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="flex h-full flex-col items-center justify-center text-center">
      <div className="mb-2 font-medium text-gray-700">
        {isAlmostDone ? "Almost finished" : "Loading..."}
      </div>
      <div className="h-2 w-64 overflow-hidden rounded-full bg-gray-200">
        <div className="h-full animate-almost-finished-progress bg-blue-500"></div>
      </div>
    </div>
  );
};
